import { AutogenLayoutJobClassCode } from "./autogen/AutogenLayoutJobClassCode";
import { DuplicateId } from "@mcleod/dispatch";

export class JobClassCode extends AutogenLayoutJobClassCode {
    onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "job_class_code",
            screenName: "Job Class Code",
            navigateToUrl: "lme/settlement/JobClassCode?mode=update&key="
        });
    }
}
